var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8889 10.6189H7.92089C10.8489 10.6189 13.2299 8.23788 13.2299 5.30988C13.2299 2.38188 10.8489 -0.00012207 7.92089 -0.00012207C4.99189 -0.00012207 2.60989 2.38188 2.60989 5.30688C2.59989 8.22688 4.9669 10.6099 7.8889 10.6189ZM4.03789 5.30988C4.03789 3.16888 5.77989 1.42788 7.92089 1.42788C10.0609 1.42788 11.8019 3.16888 11.8019 5.30988C11.8019 7.44988 10.0609 9.19188 7.92089 9.19188H7.89189C5.75989 9.18388 4.03089 7.44388 4.03789 5.30988Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00012207 16.1732C-0.00012207 19.8702 5.96188 19.8702 7.92088 19.8702C11.3199 19.8702 15.8399 19.4892 15.8399 16.1932C15.8399 12.4962 9.87988 12.4962 7.92088 12.4962C4.52088 12.4962 -0.00012207 12.8772 -0.00012207 16.1732ZM1.49988 16.1732C1.49988 14.7282 3.65988 13.9962 7.92088 13.9962C12.1809 13.9962 14.3399 14.7352 14.3399 16.1932C14.3399 17.6382 12.1809 18.3702 7.92088 18.3702C3.65988 18.3702 1.49988 17.6312 1.49988 16.1732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f7b765c0eae18e45308aa48df5d0dec4.svg";
export { ForwardRef as ReactComponent };